/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetContainersQueryVariables = Types.Exact<{
  search: Types.CargoSearch;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetContainersQuery = {
  __typename?: 'Query',
  cargos: {
    __typename?: 'CargoPage',
    totalElements: number,
    content: Array<{
      __typename?: 'Cargo',
      id: number,
      cargoNumber?: string | null,
      containerNumber?: string | null,
      loadingReference?: string | null,
      dischargingReference?: string | null,
      connectingVisitLoadingCallReferenceNumber?: string | null,
      connectingVisitDischargingCallReferenceNumber?: string | null,
      created?: number | null,
      empty?: boolean | null,
      bookingReference?: string | null,
      hasDangerousGoods?: boolean | null,
      reeferCheckType?: Types.ReeferCheckType | null,
      loaded?: number | null,
      discharged?: number | null,
      canSkipperEditLoadedTimestamp?: boolean | null,
      canSkipperEditDischargedTimestamp?: boolean | null,
      transportType?: Types.TransportType | null,
      productDetails?: string | null,
      weight?: number | null,
      grossWeight?: number | null,
      tareWeight?: number | null,
      verifiedGrossWeight?: number | null,
      imoClass?: string | null,
      billOfLadingNumber?: string | null,
      desiredTemperature?: number | null,
      temperatureRangeLower?: number | null,
      temperatureRangeUpper?: number | null,
      humidity?: number | null,
      sealed?: boolean | null,
      sealNumber?: string | null,
      remarks?: string | null,
      scacCode?: string | null,
      scacCodeDischarging?: string | null,
      overheight?: number | null,
      overlength?: number | null,
      overlengthBehind?: number | null,
      overwidthRight?: number | null,
      overwidthLeft?: number | null,
      doorOpen?: boolean | null,
      chains?: boolean | null,
      generator?: boolean | null,
      damage?: string | null,
      releasedForBarge?: boolean | null,
      releasedForTrain?: boolean | null,
      releasedForTruck?: boolean | null,
      masterBundleContainerNumber?: string | null,
      deepseaShipNameLoading?: string | null,
      deepseaShipImoLoading?: number | null,
      deepseaVoyageNumberLoading?: string | null,
      deepseaEtaLoading?: number | null,
      deepseaShipNameDischarging?: string | null,
      deepseaShipImoDischarging?: number | null,
      deepseaVoyageNumberDischarging?: string | null,
      deepseaEtaDischarging?: number | null,
      deepseaEstimateDischarge?: number | null,
      previousPort?: string | null,
      nextPort?: string | null,
      finalPort?: string | null,
      revenue?: number | null,
      charter?: {
        __typename?: 'SalesCharter',
        id: number,
        type: Types.CharterType,
        charterNumber: string,
        customerReference?: string | null,
        debtor: {
          __typename?: 'Relation',
          id: number,
          name: string
        }
      } | null,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      firstLoadingAction?: {
        __typename?: 'CargoAction',
        id: number,
        shipToShip?: boolean | null,
        connectingVisitNotes?: string | null,
        start?: number | null,
        end?: number | null,
        simulatedTimestamp?: boolean | null,
        displayAsWindow?: boolean | null,
        connectingShipPortVisit?: {
          __typename?: 'ConnectingShipPortVisit',
          id: number,
          from?: number | null,
          until?: number | null,
          lastUpdateFromAgentOn?: number | null,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string,
            bargeType?: Types.BargeType | null,
            mmsi?: number | null,
            eni?: string | null,
            planningNotes?: string | null,
            tanks: Array<{
              __typename?: 'Tank',
              id: number,
              positionNumber: number
            }>
          },
          location: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType,
            locationGroups: Array<{
              __typename?: 'Location',
              code?: string | null,
              id: number,
              description: string,
              type: Types.LocationType
            }>
          },
          agent?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          connectingShipBerthings?: Array<{
            __typename?: 'ConnectingShipBerthing',
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType,
              locationGroups: Array<{
                __typename?: 'Location',
                code?: string | null,
                id: number,
                description: string,
                type: Types.LocationType
              }>
            } | null
          }> | null
        } | null,
        connectingShipBerthing?: {
          __typename?: 'ConnectingShipBerthing',
          id?: number | null,
          window?: {
            __typename?: 'TimeWindow',
            from?: number | null,
            to?: number | null
          } | null,
          location?: {
            __typename?: 'Location',
            id: number,
            description: string,
            locationGroups: Array<{
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType
            }>
          } | null
        } | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          locationGroups: Array<{
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        viaLocation?: {
          __typename?: 'Location',
          id: number,
          description: string,
          locationGroups: Array<{
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        call?: {
          __typename?: 'Call',
          id: number,
          voyage: {
            __typename?: 'Voyage',
            id: number,
            voyageNumber: string,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string
            }
          }
        } | null,
        measurements: {
          __typename?: 'Measurements',
          locationWeight?: number | null,
          locationWeightUnit?: Types.WeightUnit | null,
          skipperWeight?: number | null,
          skipperWeightUnit?: Types.WeightUnit | null,
          locationVolume?: number | null,
          locationVolumeUnit?: Types.VolumeUnit | null,
          skipperVolume?: number | null,
          skipperVolumeUnit?: Types.VolumeUnit | null,
          ambientVolume?: number | null,
          relativeDensity?: number | null,
          productTemperature?: number | null,
          actualConsignor?: string | null,
          actualConsignee?: string | null,
          protest?: boolean | null
        }
      } | null,
      lastDischargingAction?: {
        __typename?: 'CargoAction',
        id: number,
        shipToShip?: boolean | null,
        connectingVisitNotes?: string | null,
        start?: number | null,
        end?: number | null,
        simulatedTimestamp?: boolean | null,
        displayAsWindow?: boolean | null,
        connectingShipPortVisit?: {
          __typename?: 'ConnectingShipPortVisit',
          id: number,
          from?: number | null,
          until?: number | null,
          lastUpdateFromAgentOn?: number | null,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string,
            bargeType?: Types.BargeType | null,
            mmsi?: number | null,
            eni?: string | null,
            planningNotes?: string | null,
            tanks: Array<{
              __typename?: 'Tank',
              id: number,
              positionNumber: number
            }>
          },
          location: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType,
            locationGroups: Array<{
              __typename?: 'Location',
              code?: string | null,
              id: number,
              description: string,
              type: Types.LocationType
            }>
          },
          agent?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          connectingShipBerthings?: Array<{
            __typename?: 'ConnectingShipBerthing',
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType,
              locationGroups: Array<{
                __typename?: 'Location',
                code?: string | null,
                id: number,
                description: string,
                type: Types.LocationType
              }>
            } | null
          }> | null
        } | null,
        connectingShipBerthing?: {
          __typename?: 'ConnectingShipBerthing',
          id?: number | null,
          window?: {
            __typename?: 'TimeWindow',
            from?: number | null,
            to?: number | null
          } | null,
          location?: {
            __typename?: 'Location',
            id: number,
            description: string,
            locationGroups: Array<{
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType
            }>
          } | null
        } | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          locationGroups: Array<{
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        viaLocation?: {
          __typename?: 'Location',
          id: number,
          description: string,
          locationGroups: Array<{
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        call?: {
          __typename?: 'Call',
          id: number,
          voyage: {
            __typename?: 'Voyage',
            id: number,
            voyageNumber: string,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string
            }
          }
        } | null,
        measurements: {
          __typename?: 'Measurements',
          locationWeight?: number | null,
          locationWeightUnit?: Types.WeightUnit | null,
          skipperWeight?: number | null,
          skipperWeightUnit?: Types.WeightUnit | null,
          locationVolume?: number | null,
          locationVolumeUnit?: Types.VolumeUnit | null,
          skipperVolume?: number | null,
          skipperVolumeUnit?: Types.VolumeUnit | null,
          ambientVolume?: number | null,
          relativeDensity?: number | null,
          productTemperature?: number | null,
          actualConsignor?: string | null,
          actualConsignee?: string | null,
          protest?: boolean | null
        }
      } | null,
      containerType?: {
        __typename?: 'ContainerType',
        isoTypeCode: string,
        displayCode?: string | null
      } | null,
      actions: Array<{
        __typename?: 'CargoAction',
        call?: {
          __typename?: 'Call',
          id: number,
          createTwinCall: boolean,
          location: {
            __typename?: 'Location',
            id: number,
            description: string
          },
          comments: Array<{
            __typename?: 'Comment',
            id: number,
            comment: string,
            created: number,
            createdBy: {
              __typename?: 'AccountDetails',
              id: number,
              username?: string | null,
              displayName?: string | null
            },
            label?: {
              __typename?: 'Label',
              id: number,
              type: Types.LabelType,
              text: string,
              color: string
            } | null
          }>
        } | null
      }>,
      bestLoadingMooringPosition?: {
        __typename?: 'Bolder',
        id: number,
        sequenceNumber?: number | null,
        quay: {
          __typename?: 'Quay',
          id: number,
          name1?: string | null
        }
      } | null,
      bestDischargingMooringPosition?: {
        __typename?: 'Bolder',
        id: number,
        sequenceNumber?: number | null,
        quay: {
          __typename?: 'Quay',
          id: number,
          name1?: string | null
        }
      } | null,
      unNumbers?: Array<{
        __typename?: 'UnNumber',
        id: number,
        unNumberId: string
      } | null> | null,
      product?: {
        __typename?: 'Product',
        id: number,
        code?: string | null,
        name: string,
        description?: string | null
      } | null,
      previousInlandTerminal?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      nextInlandTerminal?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      comments: Array<{
        __typename?: 'Comment',
        id: number,
        comment: string,
        created: number,
        createdBy: {
          __typename?: 'AccountDetails',
          id: number,
          username?: string | null,
          displayName?: string | null
        },
        label?: {
          __typename?: 'Label',
          id: number,
          type: Types.LabelType,
          text: string,
          color: string
        } | null
      }>
    }>
  }
};


export const GetContainersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContainers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CargoActionWithVoyage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CargoActionWithVoyage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingReference"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitLoadingCallReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitDischargingCallReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"empty"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createTwinCall"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingReference"}},{"kind":"Field","name":{"kind":"Name","value":"bestLoadingMooringPosition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"quay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bestDischargingMooringPosition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"quay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unNumberId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasDangerousGoods"}},{"kind":"Field","name":{"kind":"Name","value":"reeferCheckType"}},{"kind":"Field","name":{"kind":"Name","value":"loaded"}},{"kind":"Field","name":{"kind":"Name","value":"discharged"}},{"kind":"Field","name":{"kind":"Name","value":"canSkipperEditLoadedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"canSkipperEditDischargedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"transportType"}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"grossWeight"}},{"kind":"Field","name":{"kind":"Name","value":"tareWeight"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedGrossWeight"}},{"kind":"Field","name":{"kind":"Name","value":"imoClass"}},{"kind":"Field","name":{"kind":"Name","value":"billOfLadingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"desiredTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"temperatureRangeLower"}},{"kind":"Field","name":{"kind":"Name","value":"temperatureRangeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"humidity"}},{"kind":"Field","name":{"kind":"Name","value":"sealed"}},{"kind":"Field","name":{"kind":"Name","value":"sealNumber"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}},{"kind":"Field","name":{"kind":"Name","value":"scacCode"}},{"kind":"Field","name":{"kind":"Name","value":"scacCodeDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"overheight"}},{"kind":"Field","name":{"kind":"Name","value":"overlength"}},{"kind":"Field","name":{"kind":"Name","value":"overlengthBehind"}},{"kind":"Field","name":{"kind":"Name","value":"overwidthRight"}},{"kind":"Field","name":{"kind":"Name","value":"overwidthLeft"}},{"kind":"Field","name":{"kind":"Name","value":"doorOpen"}},{"kind":"Field","name":{"kind":"Name","value":"chains"}},{"kind":"Field","name":{"kind":"Name","value":"generator"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"releasedForBarge"}},{"kind":"Field","name":{"kind":"Name","value":"releasedForTrain"}},{"kind":"Field","name":{"kind":"Name","value":"releasedForTruck"}},{"kind":"Field","name":{"kind":"Name","value":"masterBundleContainerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaShipNameLoading"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaShipImoLoading"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaVoyageNumberLoading"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaEtaLoading"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaShipNameDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaShipImoDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaVoyageNumberDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaEtaDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaEstimateDischarge"}},{"kind":"Field","name":{"kind":"Name","value":"previousInlandTerminal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextInlandTerminal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousPort"}},{"kind":"Field","name":{"kind":"Name","value":"nextPort"}},{"kind":"Field","name":{"kind":"Name","value":"finalPort"}},{"kind":"Field","name":{"kind":"Name","value":"revenue"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CargoActionWithVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralConnectingShipPortVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viaLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralConnectingShipPortVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectingShipPortVisit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationWithGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionActuals"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ambientVolume"}},{"kind":"Field","name":{"kind":"Name","value":"relativeDensity"}},{"kind":"Field","name":{"kind":"Name","value":"productTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignor"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignee"}},{"kind":"Field","name":{"kind":"Name","value":"protest"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<GetContainersQuery, GetContainersQueryVariables>;